var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlltopics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2545_4655)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#4E77E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7734 30L13.9453 27.2812H9.78125L8.95312 30H6.34375L10.375 18.5312H13.3359L17.3828 30H14.7734ZM13.3672 25.25L12.5391 22.5938C12.487 22.4167 12.4167 22.1901 12.3281 21.9141C12.2448 21.6328 12.1589 21.349 12.0703 21.0625C11.987 20.7708 11.9193 20.5182 11.8672 20.3047C11.8151 20.5182 11.7422 20.7839 11.6484 21.1016C11.5599 21.4141 11.474 21.7109 11.3906 21.9922C11.3073 22.2734 11.2474 22.474 11.2109 22.5938L10.3906 25.25H13.3672ZM27.5826 26.64C27.6893 26.3627 27.8066 26.1067 27.9346 25.872C28.0626 25.6267 28.2066 25.3973 28.3666 25.184H19.7906V23.872H28.3666C28.2173 23.6587 28.0786 23.4347 27.9506 23.2C27.8226 22.9547 27.7053 22.6933 27.5986 22.416H28.8146C29.476 23.1947 30.2013 23.7867 30.9906 24.192V24.88C30.2013 25.264 29.476 25.8507 28.8146 26.64H27.5826ZM42.2734 30H33.7734V28.4297L39.25 20.5781H33.9219V18.5781H42.125V20.1406L36.6562 28H42.2734V30Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2545_4655"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlltopics);
export default __webpack_public_path__ + "static/media/All topics.13468176cceb9224a0b6317026315f47.svg";
export { ForwardRef as ReactComponent };